import type { Meta, StoryObj } from "@storybook/react";

import { fakeAvatarCardProps } from "@/__mocks__/mockBaseTypes";
import type {
  GroupClassSession,
  GroupClassSessionListProps,
} from "@/ui/components/groupClasses/series/session/GroupClassSessionList";
import GroupClassSessionList from "@/ui/components/groupClasses/series/session/GroupClassSessionList";

const hostOne = fakeAvatarCardProps({
  userType: "provider",
});
const hostTwo = fakeAvatarCardProps({
  userType: "provider",
});

const sessions: GroupClassSession[] = [
  {
    hosts: [hostOne, hostTwo],
    id: "monday",
    sessionCount: 16,
    timeRange: "4 - 4:30pm",
    title: "Every Monday",
  },
  {
    hosts: [hostOne],
    id: "tuesday",
    sessionCount: 8,
    timeRange: "5 - 6pm",
    title: "Every Tuesday",
  },
  {
    hosts: [hostOne, hostTwo],
    id: "wednesday",
    sessionCount: 16,
    timeRange: "4 - 5pm",
    title: "Every other Wednesday",
  },
  {
    hosts: [hostOne, hostTwo],
    id: "thursday",
    sessionCount: 24,
    timeRange: "10 - 11am",
    title: "Every 4th Thursday",
  },
  {
    hosts: [hostOne],
    id: "friday",
    sessionCount: 1,
    timeRange: "10 - 11am",
    title: "Friday, April 16",
  },
];

const StoryMeta: Meta<GroupClassSessionListProps> = {
  title: "Components/Group Classes/Session List",
  component: GroupClassSessionList,
  argTypes: {
    description: { control: "text" },
    onSelect: { action: "selected" },
    sessions: { control: "object" },
    title: { control: "text" },
  },
  args: {
    description: "Please choose the option that works best for you:",
    sessions,
    title: "Available days and times",
  },
};

type Story = StoryObj<GroupClassSessionListProps>;

const Primary: Story = {};

const NoHeader: Story = {
  args: {
    description: undefined,
    title: undefined,
  },
};

export { NoHeader, Primary };
export default StoryMeta;
